module.exports = [
    {
        "question": "1. 什么是网络借贷",
        "answers": [
            "网络借贷是指个体和个体之间通过互联网平台实现的直接借贷。个体包含自然人、法人及其他组织。"
        ]
    },
    {
        "question": "2. 什么是网贷平台",
        "answers": [
            "根据《网络借贷信息中介机构业务活动管理暂行办法》规定，网络借贷信息中介机构（即“网贷平台”）是指依法设立，专门从事网络借贷信息中介业务活动的金融信息中介公司。该类机构以互联网为主要渠道，为借款人与出借人（即贷款人）实现直接借贷提供信息搜集、信息公布、资信评估、信息交互、借贷撮合等服务。"
        ]
    },
    {
        "question": "3. 网贷平台职责",
        "answers": [
            "根据《网络借贷信息中介机构业务活动管理暂行办法》，网络借贷信息中介机构按照依法、诚信、自愿、公平的原则为借款人和出借人提供信息服务，维护出借人与借款人合法权益，不得提供增信服务，不得直接或间接归集资金，不得非法集资，不得损害国家利益和社会公共利益。",
            "借款人与出借人遵循借贷自愿、诚实守信、责任自负、风险自担的原则承担借贷风险。网络借贷信息中介机构承担客观、真实、全面、及时进行信息披露的责任，不承担借贷违约风险。"
        ]
    },
    {
        "question": "4. 借款人应当履行的义务及禁止行为",
        "answers": [
            "借款人应当履行的义务：",
            "（一）提供真实、准确、完整的用户信息及融资信息；",
            "（二）提供在所有网络借贷信息中介机构未偿还借款信息；",
            "（三）保证融资项目真实、合法，并按照约定用途使用借贷资金，不得用于出借等其他目的；",
            "（四）按照约定向出借人如实报告影响或可能影响出借人权益的重大信息；",
            "（五）确保自身具有与借款金额相匹配的还款能力并按照合同约定还款；",
            "（六）借贷合同及有关协议约定的其他义务。",
            "借款人明确禁止的行为：",
            "（一）通过故意变换身份、虚构融资项目、夸大融资项目收益前景等形式的欺诈借款；",
            "（二）同时通过多个网络借贷信息中介机构，或者通过变换项目名称、对项目内容进行非实质性变更等方式，就同一融资项目进行重复融资；",
            "（三）在网络借贷信息中介机构以外的公开场所发布同一融资项目的信息；",
            "（四）已发现网络借贷信息中介机构提供的服务中含有本办法第十条所列内容，仍进行交易；",
            "（五）法律法规和网络借贷有关监管规定禁止从事的其他活动。"
        ]
    },
    {
        "question": "5. 出借人应当履行的义务",
        "answers": [
            "出借人应当履行的义务：",
            "（一）向网络借贷信息中介机构提供真实、准确、完整的身份等信息；",
            "（二）出借资金为来源合法的自有资金；",
            "（三）了解融资项目信贷风险，确认具有相应的风险认知和承受能力；",
            "（四）自行承担借贷产生的本息损失；",
            "（五）借贷合同及有关协议约定的其他义务。"
        ]
    }
]


// WEBPACK FOOTER //
// ./src/config/Edu/Netloan.js